exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#signatureBox[data-v-6e5d012c] {\n    background-color: lightgray;\n    border: 1px dotted gray;\n    padding: 20px;\n}\nh4[data-v-6e5d012c] {\n    color: white;\n}\n", ""]);

// exports
